import moment from 'moment'

// methods here can directly be called in methods of each component
moment.locale(process.env.LOCALE)

let dictionary = {
  'zh-cn': {
    'after': '之后',
    'before': '之前',
    'day': '天',
    'hour': '小时',
    'minute': '分钟',
    'second': '秒',
    'priceNotAvaliable': '暂无金额'
  }
}

let getLocale = (tag) => {
  return dictionary[process.env.LOCALE][tag]
}

export default {
  methods: {
    sizeReadable(size) {
      let i = -1
      let byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB']
      do {
        size = size / 1024
        i++
      } while (size > 1024)

      return Math.max(size, 0.1).toFixed(1) + byteUnits[i]
    },
    durationReadable(durationInSeconds) {
      let result = ''

      if (durationInSeconds > 3600) {
        let h = parseInt(durationInSeconds / 3600, 10)
        result += (h < 10 ? `0${h}` : `${h}`) + ':'
      }

      let m = parseInt((durationInSeconds % 3600) / 60, 10)
      result += (m < 10 ? `0${m}` : `${m}`) + ':'

      let s = parseInt(durationInSeconds % 60, 10)
      result += (s < 10 ? `0${s}` : `${s}`)
      return result
    },
    dateReadable(ts, simple = false) {
      return moment(ts).format(simple ? 'YYYY-MM-DD' : 'YYYY/MM/DD HH:mm:ss')
    },
    timeDiff(ts, ts2, words = false) {
      if (typeof ts2 !== 'number' || typeof ts2 !== 'string') {
        words = ts2
        ts2 = null
      }

      let a = moment(ts)
      let b = ts2 ? moment(ts2) : moment()
      let _diff = a.diff(b)
      if (!words) {
        return _diff
      }

      let suffix = _diff > 0 ? getLocale('after') : getLocale('before')
      _diff = Math.abs(_diff)

      if (_diff > 1000 * 60 * 60 * 24) {
        return Math.abs(a.diff(b, 'days')) + getLocale('day') + suffix
      } else if (_diff > 1000 * 60 * 60) {
        return Math.abs(a.diff(b, 'hours')) + getLocale('hour') + suffix
      } else if (_diff > 1000 * 60) {
        return Math.abs(a.diff(b, 'minutes')) + getLocale('minute') + suffix
      } else {
        return Math.abs(a.diff(b, 'seconds')) + getLocale('second') + suffix
      }
    },
    priceReadableInHtml(price) {
      let _price = Number(price)

      if (isNaN(_price)) {
        return '<span>' + getLocale('priceNotAvaliable') + '</span>'
      }
      return `<span class='currency'>￥</span><span class='integer'>${Math.floor(_price)}</span>.<span class='float'>${(_price % 1).toFixed(2).substring(2)}</span>`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/utils.global.js